export const titleInfoSkele = {
	width: 143,
	height: 80
}

export const mediaInfoSkele = {
	width: 220,
	height: 120
}

export const filteredSkele = {width: 220, height: 122}

export const carouselSkele = {width: 185, height: 105}